import React, { useEffect, useState } from 'react';
import { Button } from "@mui/material";
import { GrClose } from "react-icons/gr";
import TextField from '@mui/material/TextField';
import StaticDateRangePicker from '@mui/lab/StaticDateRangePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import Box from '@mui/material/Box';
import getWindowDimensions from 'Helper';

const { width } = getWindowDimensions()

export default function ReachAfrikaDatePicker({ onChange, left, top }) {
    const [value] = React.useState([null, null]);
    const [show, setShow] = useState(false)
    
    const month = React.useMemo(() => ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], []);

    const [date, setDate] = useState()
    useEffect(() => {
        const dateObj = new Date();
        setDate(month[dateObj.getMonth()] + " " + dateObj.getDate() + ', ' + dateObj.getFullYear());
    }, [month]);
    const getData = (data) => {
        const start = month[new Date(data[0]).getMonth()] + ' ' + new Date(data[0]).getDate()  + ', ' + new Date(data[0]).getFullYear()
        const end = month[new Date(data[1]).getMonth()] + ' ' + new Date(data[1]).getDate()  + ', ' + new Date(data[1]).getFullYear()
        setDate(start+ ' - ' + end)
    }
    return (<>
        {!show ?
            <Button
                className={'bg-[#F0F3F5] rounded-[16px] text-secondary font-bold py-3 px-2 w-[100%]'}
                onClick={() => setShow(true)}>{date}</Button>
            :
            (<div className={`fixed left-[50%] top-[50%] !z-[1000] border p-2 rounded`} style={{ transform: 'translate(-50%,-50%)' }}>
                <GrClose className="absolute right-[-20px] top-[-16px]" onClick={() => setShow(false)} />

                <LocalizationProvider dateAdapter={AdapterDateFns} >
                    <StaticDateRangePicker
                        displayStaticWrapperAs={width > 360 ? 'desktop' : 'mobile'}
                        value={value ?? [null, null]}
                        onChange={onChange}
                        onAccept={(data) => { setShow(false); getData(data) }}
                        renderInput={(startProps, endProps) => (
                            <React.Fragment>
                                <TextField {...startProps} />
                                <Box sx={{ mx: 2 }}> to </Box>
                                <TextField {...endProps} />
                            </React.Fragment>
                        )}
                    />
                </LocalizationProvider>

            </div>)
        }
    </>
    );
};

